import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { sessionManager } from '@/utils/sessionManager';
import { logger } from '@/utils/logger';

export const useAuth = () => {
  const {
    isAuthenticated,
    isLoading,
    user,
    loginWithRedirect,
    logout: auth0Logout,
    getAccessTokenSilently,
  } = useAuth0();

  useEffect(() => {
    if (isAuthenticated && user) {
      sessionManager.startSession();
      logger.logLogin(user.email || user.sub || 'unknown');
    }
  }, [isAuthenticated, user]);

  const login = async () => {
    try {
      await loginWithRedirect();
    } catch (error) {
      logger.logError('Login failed', error);
      throw error;
    }
  };

  const logout = () => {
    if (user) {
      logger.logLogout(user.email || user.sub || 'unknown');
    }
    sessionManager.endSession();
    auth0Logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  const getAccessToken = async () => {
    try {
      return await getAccessTokenSilently();
    } catch (error) {
      logger.logError('Failed to get access token', error);
      throw error;
    }
  };

  return {
    isAuthenticated,
    isLoading,
    user,
    login,
    logout,
    getAccessToken,
  };
};
